// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"5caa7c06","103":"8437cd54"}[chunkId] + ".chunk.js";
};